import { EncountersIcon, HistoryIcon, MedicationIconSmall, ResultsIcon } from '@icons'
import { PatientTab, type PatientTabItem } from '@ui'
import { useState } from 'react'
import { FiUser } from 'react-icons/fi'
import Demographics from './components/Demographics'
import Encounters from './components/Encounters'
import History from './components/History'
import Medications from './components/Medications'
import Results from './components/Results'

/** Stable reference so PatientTab does not re-measure the underline every render. */
const CHART_TABS: PatientTabItem[] = [
  { value: 'demographics', label: 'Demographics', icon: <FiUser size={16} /> },
  { value: 'history', label: 'History', icon: <HistoryIcon /> },
  { value: 'results', label: 'Results', icon: <ResultsIcon /> },
  { value: 'medications', label: 'Medications', icon: <MedicationIconSmall /> },
  { value: 'encounters', label: 'Encounters', icon: <EncountersIcon /> }
]

const PatientCharts = () => {
  const [activeTab, setActiveTab] = useState('demographics')

  return (
    <div className="flex flex-col gap-5">
      {/* shrink-0: overflow-x-auto on PatientTab can otherwise collapse to 0 height in a
          min-h-0 flex column once demography cards finish loading and grow. */}
      <div className="shrink-0">
        <PatientTab activeTab={activeTab} setActiveTab={setActiveTab} tabs={CHART_TABS} />
      </div>

      <div className="min-w-0">
        {activeTab === 'demographics' ? (
          <Demographics />
        ) : activeTab === 'history' ? (
          <History />
        ) : activeTab === 'results' ? (
          <Results />
        ) : activeTab === 'medications' ? (
          <Medications />
        ) : activeTab === 'encounters' ? (
          <Encounters />
        ) : (
          <div className="rounded-lg border border-[#E5E7EB] px-6 py-8 text-sm text-[#6B7280]">
            {CHART_TABS.find(tab => tab.value === activeTab)?.label} details are not available yet.
          </div>
        )}
      </div>
    </div>
  )
}

export default PatientCharts
